// extracted by mini-css-extract-plugin
export var card = "_v4-0";